import { OrderFilter, OrdersResponse } from '../types/orders';
import api from './constants';

export interface GetOrderResponse {
  orders: any[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  }
}

export const orderApi = {
  getOrders: async (filter: OrderFilter = {}): Promise<OrdersResponse> => {
    try {
      const response = await api.get<OrdersResponse>('/orders', { params: filter });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  updateStatus: async (orderId: string, data: any) => {
    try {
      const response = await api.put(`/orders/${orderId}/status`, data);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  updateOrderNotes: async (orderId: string, notes: string) => {
    try {
      const response = await api.put(`/orders/${orderId}/notes`, { notes });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },
  getReportOrders: async (filter: OrderFilter = {}): Promise<any> => {
    try {
      const response = await api.get<any>('/orders/report', { params: filter });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
};
